module.exports = __webpack_public_path__ + "d421e57a9c83c90cc2951bbadffecc5a.png";